
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealCategoryFilterEntity } from '../../domain/entities/MealCategoryFilterEntity'

export class MealCategoryFilterModel extends MealCategoryFilterEntity {
    companyId?: number
    mealTierId?: number
    constructor(dataDto: MealCategoryFilterEntity) {
        super()
        mapEntityProperties<MealCategoryFilterModel>(this, dataDto, {
            exclude: ["company", "mealTier"],
            map: {
                companyId: dataDto.company?.id,
                mealTierId: dataDto.mealTier?.id
            }
        })
    }
}